// IMPORTS GO HERE
import _ from 'underscore';
import $ from 'jquery';
import render from '../../utilities/render';
import moment from "moment";
require('./scheduler.less');

const baseTemplateHtml = require('./html/baseTemplate.html');
const dateContainerHtml = require('./html/templates/dateContainer.html');
const availTimeContainerHtml = require('./html/templates/availTimeContainer.html');
const timeBlockTemplateHtml = require('./html/templates/timeBlockTemplate.html');

// rename to match what this component is...
export default function Scheduler(options = {}) {
  // functional code for component here
  let self = this;

  let targetEl = $(options.target);
  let data = options.data || [];
  let selectedTime, selectedDayIndex, timeStamp, selectedTimeIndex, selectionToSend;

  let daysArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let monthArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  self.init = function () {
    buildHtml();
    bindElements();
    setInitialState();
  }

  self.getSelection = function () {
    return selectionToSend = [
      {
        "date": data[selectedDayIndex].date,
        "availTime": selectedTime
      }
    ];
  }

  function buildHtml() {
    const schedulerHtml = render(
      baseTemplateHtml, {
        availDates: renderAvailDate(),
        availTimes: renderAvailTimeBlocks()
      });

    targetEl.html(schedulerHtml);
  }

  function renderAvailDate() {   
    let availDatesHtml = (data).map((day) => {
      let dateToRender = new Date(day.date);
      let dateTextToShow = `${daysArr[dateToRender.getDay()]}, ${monthArr[dateToRender.getMonth()]} ${dateToRender.getDate()}${nthDay(dateToRender.getDate())}`;
      return render(dateContainerHtml, {
        date: dateTextToShow
      });
    });
    return availDatesHtml.join('');
  }

  function renderAvailTimeBlocks() {
    let availTimeBlockHtml = (data).map((day,index) => {
      let availTimesArr = day.availTime || [];
      return render(availTimeContainerHtml, {
        timeBlock: renderTimeBlock(availTimesArr),
        index
      });
    });
    return availTimeBlockHtml.join("");
  }

  function renderTimeBlock(arr) {
    let timeBlockHtml;

    if (arr.length > 0) {
      timeBlockHtml = (arr).map((arrEl, index) => {
        timeStamp = moment(arrEl.startTime, 'HH:mm').format('h:mm A');
        return render(timeBlockTemplateHtml, {
          timeStamp,
          index
        });
      });
      return timeBlockHtml.join('');
    } else {
      return timeBlockHtml = `<div class="no-avail q-boldest">No Availability</div>`;
    }
  }

  function nthDay(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  function bindElements() {
    targetEl.on('click', '.time-block-div', onTimeBlockCheck);
  }

  function onTimeBlockCheck() {
    selectedDayIndex = $(this).closest('td').data('day-index');
    selectedTimeIndex = $(this).data('time-slot-index');
    selectedTime = data[selectedDayIndex].availTime[selectedTimeIndex];
  }

  let activeIndex = options.activeIndex;
  

  function setInitialState() {
    $('.no-avail').closest('td').addClass('no-avail-cell');
    $(`table thead th:eq(${activeIndex})`).addClass('active'); 
  }

};


// WEBPACK FOOTER //
// ./src/components/scheduler/index.js